import Splide from '@splidejs/splide';

export const slider = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const splideElement = document.querySelector('.slider');

        if (splideElement) {
            new Splide(splideElement, {
                type: 'loop',
                autoplay: true,
                perPage: 1,
                perMove: 1,
                arrows: false,
                pagination: true,
                gap: 80,
                drag: true,
                breakpoints: {
                    1024: {
                        gap: 40,
                    },
                    756: {
                        gap: 15,
                    },
                    560: {
                        gap: 10,
                    },
                },
            }).mount();
        }
    });
};

export const slidersWithThumbnails = document.getElementsByClassName(
    'image-slider-with-thumbnails'
);

for (let i = 0; i < slidersWithThumbnails.length; i++) {
    // const secondarySliderEl = slidersWithThumbnails[i].querySelector('.secondary-slider');
    // const secondarySlider = new Splide( secondarySliderEl, {
    // 	rewind      : true,
    // 	fixedWidth  : 100,
    // 	fixedHeight : 64,
    // 	isNavigation: true,
    // 	gap         : 10,
    // 	focus       : 'center',
    // 	pagination  : false,
    // 	arrows		: false,
    // 	cover       : true,
    // 	breakpoints : {
    // 		'600': {
    // 			fixedWidth  : 66,
    // 			fixedHeight : 40,
    // 		}
    // 	}
    // } ).mount();

    const primarySliderEl =
        slidersWithThumbnails[i].querySelector('.primary-slider');
    const primarySlider = new Splide(primarySliderEl, {
        type: 'fade',
        // heightRatio: 0.5,
        rewind: true,
        // pagination : false,
        arrows: true,
        cover: true,
    });

    // Set the thumbnails slider as a sync target and then call mount.
    // primarySlider.sync( secondarySlider ).mount();
    // post-page slider mount
    primarySlider.mount();
}

slider();